import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { BankService } from '../../../../../core/services/bank/bank/bank.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { VehicleService } from '../../../../../core/services/vehicle/vehicle/vehicle.service'
import { SupplierService } from '../../../../../core/services/person/supplier/supplier.service'
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { Observable, of } from 'rxjs'
import { debounceTime, distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { VehicleTypeService } from '../../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { VehicleModelService } from '../../../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { MatIconModule } from "@angular/material/icon";
import { ModalSupplierComponent } from '../../../../person/supplier/modal_supplier/modal-supplier.component'
import { DocumentTypeService } from '../../../../../core/services/document/document-type/document-type.service'

interface Supplier {
  id: number;
  razaoSocial: string;
  cnpj: string;
}



interface VehicleType {
  id: number
  modelo: string
}

@Component({
  selector: 'vehicle-edit-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatInputModule,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    NgxMaskDirective,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './vehicle-edit-form.component.html',
  styleUrl: './vehicle-edit-form.component.scss',
  providers: [VehicleService, provideNgxMask()],
  standalone: true,
})
export class VehicleEditFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private bankService: BankService,
    private snackbar: SnackbarCustomService,
    private vehicleService: VehicleService,
    private vehicleTypeService: VehicleTypeService,
    private supplierService: SupplierService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private typeDocumentService: DocumentTypeService,
    private vehicleModelService: VehicleModelService,
    public dialogRef: MatDialogRef<VehicleEditFormComponent>
  ) { }

  @Output() responseCreate = new EventEmitter()
  @Output() response = new EventEmitter()
  @Input() item: any

  filteredSuppliers: Observable<any[]> = of([]);
  filteredModelsVehicles: Observable<any[]> = of([]);
  listItems: Supplier[] = []
  AlllistTypeVehicles: any[] = []
  form: FormGroup = new FormGroup({})
  loading = false
  edit: any = false
  result = false
  plateExists = false
  supplierSelected: any = {}
  typeDocuments: any = []
  dataItem: any = {}
  checkingPlate = false;
  file: File | null = null
  allowedTypes = []
  itemsList: any[] = []
  supplierId:any
  formDoc: FormGroup = new FormGroup({})

  ngOnInit(): void {
    this.createForm()
    this.listSupplier()
    this.listAllTypeVehicles()
    this.fillForm()
    this.listTypeDoc()
    // this.form.get('active')?.disable()
    this.form.get('VehicleCode')?.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(plate => {
        // Só continua se a placa tiver exatamente 7 caracteres
        return plate && plate.length === 7;
      })
    ).subscribe(plate => {
      this.checkPlateAvailability(plate);
    });
  }



  private plateCache: Record<string, boolean> = {};

  private setupAutocomplete(): void {
    this.filteredSuppliers = this.form.get('supplier')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      startWith(''),
      map(value => this._filter(value))
    );
  }


  private TyperVehicleAutocomplete(): void {
    this.filteredModelsVehicles = this.form.get('TypeVehicle')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterTypeVehicles(value))
    )
  }


  private _filter(value: string | Supplier | null): Supplier[] {
    if (!value || typeof value !== 'string') {
      return this.listItems.slice();
    }

    const filterValue = value.toLowerCase();
    return this.listItems.filter(supplier =>
      supplier.razaoSocial.toLowerCase().includes(filterValue) ||
      supplier.cnpj.toLowerCase().includes(filterValue)
    );
  }



  private _filterTypeVehicles(value: string | VehicleType | null): VehicleType[] {
    if (!value || typeof value !== 'string') {
      return this.AlllistTypeVehicles.slice();
    }

    const filterValue = value.toLowerCase();
    return this.AlllistTypeVehicles.filter(model =>
      model.modelo.toLowerCase().includes(filterValue)
    );
  }




  displayType(vehicle: VehicleType): string {
    if (!vehicle) return ''
    return vehicle.modelo;
  }


  private setTypeVehicleValue(): void {
    const typeVehicle = this.AlllistTypeVehicles.find(
      item => item.id === this.dataItem.veiculoModeloId
    );

    if (typeVehicle) {
      // Aqui está o importante - deve ser o objeto completo, não apenas a descrição
      this.form.get('TypeVehicle')?.setValue(typeVehicle);
    } else {
      console.warn('Tipo de veículo não encontrado para o ID:', this.dataItem.veiculoModeloId);
    }
  }


  private setSupplierValue(): void {
    const supplier = this.listItems.find(
      item => item.id === this.dataItem.fornecedorId
    );

    if (supplier) {
      // Aqui está o importante - deve ser o objeto completo, não apenas a descrição
      this.form.get('supplier')?.setValue(supplier.razaoSocial);
      this.supplierId = supplier.id
    } else {
      console.warn('fornecedor não encontrado para o ID:', this.dataItem.fornecedorId);
    }
  }

  fillForm() {
    this.dataItem = this.data.item
    this.edit = this.data.frota

  
    this.form.get('active')?.setValue(this.dataItem.isFrota == 'S' ? true : false)
    this.form.get('active')?.disable()

    if (this.AlllistTypeVehicles && this.AlllistTypeVehicles.length > 0) {
      this.setTypeVehicleValue();
    } else {
      // Se a lista ainda não carregou, esperamos ela carregar
      this.vehicleModelService.listVehicleModel().subscribe({
        next: (res) => {
          this.AlllistTypeVehicles = res.data;
          this.TyperVehicleAutocomplete();
          this.setTypeVehicleValue();
        },
        error: (err) => {
        }
      });
    }

    if (this.edit == false) {
      if (this.listItems && this.listItems.length > 0) {
        this.setSupplierValue();
      } else {
        // Se a lista ainda não carregou, esperamos ela carregar
        this.supplierService.listSupplierLegal().subscribe({
          next: (res) => {
            this.listItems = res.data;
            this.setupAutocomplete();
            this.setSupplierValue();
          },
          error: (err) => {
          }
        });
      }
    }


    //  this.form.get('TypeVehicle')?.setValue(this.dataItem.tipoVeiculoId)
    this.form.get('VehicleCode')?.setValue(this.dataItem.placa)



    if (this.form.get('active')?.value == true) {
      this.form.get('supplier')?.disable()
    } else {
      this.form.get('supplier')?.enable()
    }
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
  }

  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }

  formatCNPJ(cnpj: string): string {
    // Formatação básica de CNPJ: 00.000.000/0000-00
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }

  listAllTypeVehicles() {
    this.vehicleModelService.listVehicleModel().subscribe({

      next: (res) => {

        this.AlllistTypeVehicles = res.data
        this.TyperVehicleAutocomplete()
      },
      error: (err) => {
      }
    })
  }


  checkPlateAvailability(plate: string): void {
    this.plateExists = false
    // Verifica se a placa está vazia ou incompleta
    if (!plate || plate.length < 7) {
      this.plateExists = false;
      this.checkingPlate = false;
      return;
    }

    // Verifica se já temos essa placa no cache
    if (this.plateCache.hasOwnProperty(plate)) {
      this.plateExists = this.plateCache[plate];
      this.checkingPlate = false;
      return;
    }

    this.checkingPlate = true;
    this.vehicleService.getVehicleModelbyPlate(plate).subscribe({
      next: (res) => {
        this.plateExists = res.statusCode === 200;
        this.plateCache[plate] = this.plateExists;
        this.checkingPlate = false;
      },
      error: (err) => {
        this.plateExists = false;
        this.checkingPlate = false;
        console.error('Erro ao verificar placa:', err);
      }
    });
  }




  // searchVehicleCode(placa: string) {
  //   this.vehicleService.getVehicleModelbyPlate(this.form.get('VehicleCode')?.value).subscribe({

  //     next: (res) => {
  //       if (res.statusCode == 200) {
  //         this.result = true
  //       } else {
  //         this.result = false
  //       }
  //     },
  //     error: (err: ErrorRequestModel) => {
  //       this.snackbar.errorRequest(err)
  //     }
  //   })
  // }


  editItem() {
    // this.searchVehicleCode(this.form.get('VehicleCode')?.value.placa)
    // if (this.result == false) {
    this.loading = true
    const model = this.createModel()
    this.vehicleService.editVehicleModel(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        // this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.createForm()
      },
    })
    // } else {
    //   this.snackbar.error('Placa ja cadastrada')
    // }
  }

  listSupplier() {

    this.supplierService.listSupplierLegal().subscribe({
      next: (res) => {
        this.listItems = res.data
        this.setupAutocomplete()
        // this.setupAutocomplete();
      },
      error: () => {
        console.error('Ocorreu um erro ao listar os fornecedores')
      }
    })
  }


  createModel() {

    return {
      id: this.data.item.id,
      placa: this.form.get('VehicleCode')?.value.toUpperCase(),
      isFrota: this.form.get('active')?.value == true ? 'S' : 'N',
      veiculoModeloId: this.form.get('TypeVehicle')?.value.id,
      fornecedorId: this.supplierSelected.id ? this.supplierSelected.id : this.supplierId,
    }
    // const model = new VehicleCreateModel()


    // model.Vehicle = {
    //   VeiculoModeloId: this.form.get('TypeVehicle')?.value.id,
    //   Placa: this.form.get('VehicleCode')?.value.toUpperCase(),
    //   IsFrota: this.form.get('active')?.value == true ? 'S' : 'N',
    //   FornecedorId: this.supplierSelected.id ? this.supplierSelected.id : this.supplierId,
    //   Documentos: this.itemsList.map(item => ({
    //     descricao: item.descricao,
    //     tipoDocId: item.tipoDocId.id ? item.tipoDocId.id : '',
    //     arquivo: item.arquivo
    //   })),
    //   // Documentos: [{
    //   //   descricao: this.form.get('description')?.value,
    //   //   tipoDocId: this.form.get('typeDocument')?.value.id ? this.form.get('typeDocument')?.value.id : '',
    //   //   arquivo: this.file
    //   // }]
    // }
    // return model.toFormData()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      VehicleCode: [null, [Validators.required]],
      TypeVehicle: ['', [Validators.required]],
      typeDocument: [''],
      file: [''],
      description: [''],
      supplier: [''],
      active: [false],
    })
  }

  close() {
    this.dialogRef.close({ success: true })
  }

  addDocument() {

    const veiculoId = this.data.item.id
    const descricao = this.form.get('description')?.value || '';
    const tipoDoc = this.form.get('typeDocument')?.value;
    const tipoDocId = tipoDoc || '';
    const tipoDocDescricao = tipoDoc?.descricao || '';
    const arquivo = this.file;
    

    // Validação simples (opcional)
    if (!descricao || !tipoDocId || !arquivo) {
      this.snackbar.error('Preencha todos os campos do documento!');
      return;
    }


    const dados = {
      veiculoId,
      descricao,
      tipoDocId,
      tipoDocDescricao,
      arquivo,
      nomeArquivo: arquivo.name
    }

    this.response.emit(dados)


    // Limpe os campos do formulário de documentos
    this.form.get('description')?.setValue('');
    this.form.get('typeDocument')?.setValue('');
    this.form.get('file')?.setValue('');
    this.file = null;
  }

  listTypeDoc() {
    this.typeDocumentService.listDocumentType().subscribe({
      next: (res) => {
        this.typeDocuments = res.data
      },
      error: (err) => {
        this.typeDocuments = []
      }
    })
  }

  checkFormDocument(){
    this.formDoc = this.formBuilder.group({
      typeDocument: ['', [Validators.required]],
      file: [''],
      description: [''],
    })
    
  }

}
